import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }
});
export const figure4 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        marginLeft: 270,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'bar',
        height: '600px',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },
  
      colors: ['#70ad47', '#ed7d31','#5b9ad5'],
  
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
  
      plotOptions: {
        series: {
          borderWidth: 0,
          marker: {
            symbol: 'circle',
            enabled: false,
            states: {
              hover: {
                enabled: true,
                radius: 5
              }
            }
          }
        }
      },
  
      exporting: {
        enabled: false
      },

      xAxis: [{
        reversed: true,
        categories: [ "Amérique latine et Caraïbes", "Asie", "Océanie","Afrique", "Monde" ],
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          }
        },
      }],
      yAxis: [{
        labels: {
          	format: '{value}',
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          },
        },
        max: 25,
        min: 0,
        tickInterval: 5,
        gridLineWidth: 2,
        title: {
          text: 'Pourcentage',
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        }
      }],
      tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
          padding: 0
        }
      },
      legend: {
        enabled: false,
      },
  
      series: [      
      {
        name: '2021',
        tooltip: {
          valueSuffix: '%'
        },
        dataLabels: {
          enabled: true,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
        },
        data: [ 8.6, 9.1, 5.8, 20.2, 9.8 ],
      },

      {
        name: '2020',
        tooltip: {
          valueSuffix: '%'
        },
        dataLabels: {
          enabled: true,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
        },
        data: [ 8.0, 8.6, 5.4, 19.6, 9.3],
      },

      {
        name: '2015',
        tooltip: {
          valueSuffix: '%'
        },
        dataLabels: {
          enabled: true,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
        },
        data: [5.8, 8.0, 5.7, 15.8, 8.0],
      },

    
    ]
}